export interface Translation {
  language: string
  name: string
}

export enum MultimediaType {
  Image = 'Image',
  Video = 'Video',
}
